/**
 * Printer Storage Utility
 * Persists selected Bluetooth printer using localStorage (works in Capacitor webview)
 */

const STORAGE_KEY_PRINTER = 'bluetooth_printer_selection';
const STORAGE_KEY_LAST_CONNECTED = 'bluetooth_printer_last_connected';

export interface StoredPrinter {
  address: string;
  name?: string;
  lastConnectedAt?: number;
}

/**
 * Save selected printer to storage
 */
export function savePrinterSelection(printer: StoredPrinter): void {
  try {
    const data = JSON.stringify({
      ...printer,
      lastConnectedAt: Date.now(),
    });
    localStorage.setItem(STORAGE_KEY_PRINTER, data);
    localStorage.setItem(STORAGE_KEY_LAST_CONNECTED, String(Date.now()));
  } catch (e) {
    console.warn('[PrinterStorage] Failed to save printer:', e);
  }
}

/**
 * Get stored printer selection
 */
export function getStoredPrinter(): StoredPrinter | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PRINTER);
    if (!raw) return null;
    return JSON.parse(raw) as StoredPrinter;
  } catch (e) {
    console.warn('[PrinterStorage] Failed to read stored printer:', e);
    return null;
  }
}

/**
 * Clear stored printer (call on disconnect)
 */
export function clearStoredPrinter(): void {
  try {
    localStorage.removeItem(STORAGE_KEY_PRINTER);
    localStorage.removeItem(STORAGE_KEY_LAST_CONNECTED);
  } catch (e) {
    console.warn('[PrinterStorage] Failed to clear printer:', e);
  }
}

/**
 * Check if we have a stored printer for auto-connect
 */
export function hasStoredPrinter(): boolean {
  return getStoredPrinter() !== null;
}
